module.exports = __webpack_public_path__ + "img/cookies.da239693.jpg";